var selectedDropdown = document.querySelector('#SingleOptionSelector');
document.addEventListener("variant:change", (e) => {
  if (selectedDropdown) {
    selectedDropdown.value = e.detail.variant?.id;
  }
  document.querySelector('.var-title').textContent = e.detail.variant?.title;
  const atcCustomButtons = document.querySelector('.floating-cart .add-to-cart');
  if (e.detail.variant.available) {
    atcCustomButtons.textContent = 'Add to cart';
    atcCustomButtons.disabled = false;
  } else {
    atcCustomButtons.textContent = 'Sold out';
    atcCustomButtons.disabled = true;
  }
  intialQty();
})

if(selectedDropdown){
  selectedDropdown.addEventListener("change", function(evt){
    var variantJson = document.querySelector('[data-product-json]');
    var variantObject = JSON.parse(variantJson.innerHTML);
    var variantsArray = variantObject.variants;
    let filterVariant = variantsArray.filter(function (variant) {
     if(variant.id == evt.target.value){
      return variant;
     }
    })
    var OptionVal1 = filterVariant[0].option1;
    if(OptionVal1 != 'null'){
      // $(`[data-value="${OptionVal1}"] input`).trigger("click");
      document.querySelector(`[data-value="${OptionVal1}"] input`).click();
    }
  
    var OptionVal2 = filterVariant[0].option2;
    if(OptionVal2 != ''){
      document.querySelector(`[data-value="${OptionVal2}"] input`).click();
    }
    var OptionVal3 = filterVariant[0].option3;
    if(OptionVal3 != ''){
      document.querySelector(`[data-value="${OptionVal3}"] input`).click();
    }
    
  });
}
const intialQty = () => {
  var floating_init_QTY = document.querySelector('.floating-cart [name="quantity"]');
  var initqty = document.querySelector('.product__quantity [name="quantity"]');
  if(initqty && floating_init_QTY){
    floating_init_QTY.value = initqty.value;
  }
}

window.addEventListener('DOMContentLoaded', () => {
  setTimeout(() => {
    intialQty();
  }, 1000);
  var customButtons = document.querySelector('.floating-cart .add-to-cart');
  if(customButtons){
    customButtons.addEventListener('click', () => {
      document.querySelector('.product-single__meta .add-to-cart').click();
    });
  }
  if (window.innerWidth >= 1024) {
    // const colorSwatches = document.querySelectorAll('.template-product .color-swatch');
    // const hoveredImg = document.querySelector('.product__main-photos .hovered-img');

    // colorSwatches.forEach((swatch) => {
    //     swatch.addEventListener('mouseenter', () => {
    //         const imgUrl = swatch.getAttribute('data-imgurl');
    //         hoveredImg.style.opacity = '1';
    //         hoveredImg.style.backgroundRepeat = 'no-repeat';
    //         hoveredImg.style.backgroundSize = 'cover';
    //         hoveredImg.style.backgroundImage = `url(${imgUrl})`;
    //     });

    //     swatch.addEventListener('mouseleave', () => {
    //         hoveredImg.style.opacity = '0';
    //     });
    // });
    var hoveredImg = document.querySelectorAll(".product__main-photos .hovered-img");
    var featuredImages = document.querySelectorAll(".nn");
    var z;
    featuredImages.forEach((val) => {
      if (val.innerHTML != "") {
        z = val.innerHTML;
      }
    });
    img_url = "//www.highstar.in/cdn/shop/";
    if(z != null){
      var featured_img = z.split("---");
      const colorSwatches = document.querySelectorAll(".template-product .color-swatch");
      colorSwatches.forEach((swatch) => {
      swatch.addEventListener("mouseenter", () => {
        const swatch_img = swatch.getAttribute("data");
        
        for (i = 0; i < featured_img.length - 1; i++) {
          let x = featured_img[i].split(",");
          if (x[x.length - 1] == swatch_img) {
            for (j = 0; j < x.length - 1; j++) {
              hoveredImg[j].innerHTML = `<div class='images'><img src='${img_url+""+ x[j]}'></div>`;
            }
          }
        }
      });
      swatch.addEventListener("mouseleave", () => {
        hoveredImg.forEach((img) => {
          img.innerHTML = "";
        });
      });
    });
    }
  }

  const tab = document.querySelectorAll('ul.shopify-tabs > li');
  if(tab){
    tab.forEach(function (li) {
      li.addEventListener('click', function () {
        var tab_id = li.getAttribute('data-tab');
        tab.forEach(function (li) {
          li.classList.remove('current');
        });
        document.querySelectorAll('.tab').forEach(function (content) {
          content.classList.remove('current');
        });

        li.classList.add('current');
        document.getElementById(tab_id).classList.add('current');
      });
    });
  }

  if (window.innerWidth > 768) {
    var desktopswiper = new Swiper(".enable_slider .mySwiper", {
      spaceBetween: 10,
      loop: true,
      freeMode: true,
      direction: 'vertical',
      watchSlidesProgress: true,
      autoHeight:true,
      mousewheel: true,
      slidesPerView: 'auto',
      slidesPerGroup: 1,
      updateOnWindowResize: true,
    });

    var swiper2 = new Swiper(".enable_slider .mySwiper2", {
      spaceBetween: 2,
      slidesPerView: 1,
      loop: true,
      autoHeight:true,
      pagination: {
        el: '.swiper-pagination[data-main-product]',
        clickable: true
      },
      thumbs: {
        swiper: desktopswiper,
      }
    });   
  }
  else{
    if (window.innerWidth <= 768) {
      var swiper3 = new Swiper(".product__main-photos.mySwiper2", {
        spaceBetween: 1,
        slidesPerView: 1,
        loop: true,
        autoHeight:true,
        pagination: {
          el: '.product__main-photos .swiper-pagination[data-main-product]',
          clickable: true
        }
      });   
    }
    let gridHeight = document.querySelector('.product__main-photos .product-slideshow ');
    let totalGap = document.querySelector('.product-image-main');
    let containerHeight = totalGap.offsetHeight + 30;
    gridHeight.style.height = containerHeight + 'px';
  }
});